import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppConfirmService } from '../../../../../shared/services/app-confirm/app-confirm.service';
import { FatDoctoIDI } from '../../../../../shared/interfaces/fat-docto-i-di';
import { FatDoctoIDIService } from 'app/shared/services/fat-docto-i-di.service';
import { Estado } from 'app/shared/interfaces/estado';
import { Estados } from 'app/shared/inmemory-db/estados';
import { LayoutService } from 'app/shared/services/layout.service';
import { ProdutoService } from 'app/shared/services/produto.service';
import { ProdutoEnums } from 'app/shared/interfaces/produto-enums';
import { CadastroService } from 'app/shared/services/cadastro.service';
import { Cadastro } from 'app/shared/interfaces/cadastro';
import { CidadeService } from 'app/shared/services/cidade.service';
import { Cidade } from 'app/shared/interfaces/cidade';
import { Observable, of, Subject } from 'rxjs';
import { debounceTime, finalize, map, switchMap, takeUntil, tap } from 'rxjs/operators';


@Component({
  selector: 'app-lancamento-item-di-popup',
  templateUrl: './lancamento-item-di-popup.component.html',
  styleUrls: ['./lancamento-item-di-popup.component.scss'],
})
export class LancamentoItemDIPopupComponent implements OnInit, OnDestroy {
  public fatDoctoIDIForm: FormGroup;
  public isSaving = false;

  fatDoctoIDI: FatDoctoIDI;
  public layoutConf: any;

  estados: Estado[];
  public enums: ProdutoEnums;
  cadastrosCnpj: Cadastro[] = [];
  cadastrosExportador: Cadastro[] = [];
  cadastrosFabricante: Cadastro[] = [];
  cidadesDesembaraco: Cidade[] = [];
  isLoadingCnpj = false;
  isLoadingExportador = false;
  isLoadingFabricante = false;
  isLoadingCidadeDesembaraco = false;
  private _onDestroy = new Subject<void>();

  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  maskCnpj = {
    mask: 'SS.SSS.SSS/SSSS-00',
    definitions: { S: /[0-9A-Za-z]/ },
    prepare: (str: string) => (str || '').toUpperCase(),
    lazy: true,
    placeholderChar: '_'
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoItemDIPopupComponent>,
    private fb: FormBuilder,
    private confirmService: AppConfirmService,
    private fatDoctoIDIService: FatDoctoIDIService,
    private snack: MatSnackBar,
    private layout: LayoutService,
    private produtoService: ProdutoService,
    private cadastroService: CadastroService,
    private cidadeService: CidadeService,
  ) {
    this.estados = new Estados().estados;
  }

  ngOnInit() {
    this.fatDoctoIDI = this.data?.payload;
    if (!this.fatDoctoIDI) {
      this.snack.open('Falha ao abrir DI: item não informado.', 'ERRO', { verticalPosition: 'top', duration: 6500 });
      this.dialogRef.close();
      return;
    }

    this.layoutConf = this.layout.layoutConf;
    this.buildForm(this.fatDoctoIDI);
    this.bindAutocompleteCnpj();
    this.bindAutocompleteExportador();
    this.bindAutocompleteFabricante();
    this.bindAutocompleteCidadeDesembaraco();
    this.produtoService.getEnums().subscribe(enums => {
      this.enums = enums;
    });
  }

  get produtoResumo(): string {
    const produto = this.fatDoctoIDI?.fatDoctoI?.id?.fatProduto;
    if (!produto) {
      return '';
    }
    return `${produto.codigo} - ${produto.descricao}`;
  }

  buildForm(fatDoctoIDI: FatDoctoIDI) {
    this.fatDoctoIDIForm = this.fb.group({
      id: [fatDoctoIDI?.id],
      fatDoctoI: [fatDoctoIDI?.fatDoctoI],
      numeroRegistro: [fatDoctoIDI?.numeroRegistro ?? '', [Validators.required]],
      dataRegistro: [fatDoctoIDI?.dataRegistro ?? '', [Validators.required]],
      localDesembaraco: [fatDoctoIDI?.localDesembaraco ?? '', [Validators.required]],
      ufDesembaraco: [fatDoctoIDI?.ufDesembaraco ?? '', [Validators.required]],
      dataDesembaraco: [fatDoctoIDI?.dataDesembaraco ?? '', [Validators.required]],
      transporteInternacional: [fatDoctoIDI?.transporteInternacional ?? '', [Validators.required]],
      valorAFRMM: [fatDoctoIDI?.valorAFRMM ?? ''],
      formaImportacaoIntermediacao: [fatDoctoIDI?.formaImportacaoIntermediacao ?? '', [Validators.required]],
      cnpj: [fatDoctoIDI?.cnpj ?? '', [Validators.required]],
      ufTerceiro: [fatDoctoIDI?.ufTerceiro ?? '', [Validators.required, Validators.pattern(/^[A-Za-z]{2}$/)]],
      codigoExportador: [fatDoctoIDI?.codigoExportador ?? '', [Validators.required]],
      numero: [fatDoctoIDI?.numero??''],
      sequencial: [fatDoctoIDI?.sequencial??''],
      codigoFabricante: [fatDoctoIDI?.codigoFabricante??''],
      desconto: [fatDoctoIDI?.desconto??''],
      numeroAtoConcessorioDrawback: [fatDoctoIDI?.numeroAtoConcessorioDrawback??''],
      transientFatDoctoIUuid: [fatDoctoIDI?.transientFatDoctoIUuid??''],
      uuid: [fatDoctoIDI?.uuid??''],
      issueDate: [fatDoctoIDI?.issueDate??''],
      updatedAt: [fatDoctoIDI?.updatedAt??''],
      usuarioLog: [fatDoctoIDI?.usuarioLog??''],
    })

  }

  save(): void {
    if (this.isSaving) {
      return;
    }

    this.fatDoctoIDIForm.markAllAsTouched();

    if (this.fatDoctoIDIForm.invalid) {
      const msg = 'Campos obrigatórios não preenchidos, verifique!';
      this.snack.open(msg, 'ERRO', { verticalPosition: 'top', duration: 6500 });
      return;
    }

    const payload = this.normalizePayloadBeforeSave();
    if (!payload) {
      return;
    }

    this.isSaving = true;

    this.fatDoctoIDIService.saveOrUpdate(payload).subscribe(
      (val) => {
        this.isSaving = false;
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, DI-Declaração de Importação Salvo com Sucesso!', error: false
        });
        this.dialogRef.close(val);
      },
      (err) => {
        this.isSaving = false;
        const message = this.extractBackendErrorMessage(err);
        this.snack.open(message, 'ERRO', {
          verticalPosition: 'top',
          duration: 9000,
        });
        this.confirmService.confirm({
          title: 'ERRO AO SALVAR, VERIFIQUE',
          message,
          error: true
        });
      }
    );
  }

  private extractBackendErrorMessage(err: any): string {
    const candidates = [
      err?.error?.message,
      err?.error?.error,
      err?.error?.status,
      err?.message,
      err?.statusText,
    ];

    const backendMsg = candidates.find((m) => typeof m === 'string' && m.trim().length > 0);
    if (!backendMsg) {
      return 'Erro ao salvar DI. Verifique os dados da declaração de importação e tente novamente.';
    }

    return this.normalizeBackendMessage(backendMsg);
  }

  private normalizePayloadBeforeSave(): FatDoctoIDI | null {
    const raw = this.fatDoctoIDIForm.value as FatDoctoIDI;
    const cnpj = this.onlyNumbers(raw?.cnpj);
    const ufTerceiro = (raw?.ufTerceiro ?? '').toString().trim().toUpperCase();
    const numeroAtoConcessorioDrawback = this.parseOptionalInteger(raw?.numeroAtoConcessorioDrawback);
    const numero = this.parseOptionalInteger(raw?.numero);
    const sequencial = this.parseOptionalInteger(raw?.sequencial);
    const desconto = this.parseOptionalDecimal(raw?.desconto, 0);

    if (cnpj.length !== 14) {
      this.snack.open('CNPJ do adquirente inválido. Informe 14 dígitos.', 'ERRO', { verticalPosition: 'top', duration: 6500 });
      return null;
    }

    if (!/^[A-Z]{2}$/.test(ufTerceiro)) {
      this.snack.open('UF do adquirente inválida. Informe 2 letras (ex: SP).', 'ERRO', { verticalPosition: 'top', duration: 6500 });
      return null;
    }

    return {
      id: raw?.id ?? 0,
      fatDoctoI: {
        id: {
          fatDoctoCControle: raw?.fatDoctoI?.id?.fatDoctoCControle,
        },
        uuid: raw?.fatDoctoI?.uuid,
      } as any,
      numeroRegistro: (raw?.numeroRegistro ?? '').toString().trim(),
      dataRegistro: raw?.dataRegistro,
      localDesembaraco: (raw?.localDesembaraco ?? '').toString().trim(),
      ufDesembaraco: raw?.ufDesembaraco,
      dataDesembaraco: raw?.dataDesembaraco,
      transporteInternacional: raw?.transporteInternacional,
      valorAFRMM: this.parseOptionalDecimal(raw?.valorAFRMM, 0),
      formaImportacaoIntermediacao: raw?.formaImportacaoIntermediacao,
      cnpj,
      ufTerceiro,
      codigoExportador: (raw?.codigoExportador ?? '').toString().trim(),
      numero,
      sequencial,
      codigoFabricante: (raw?.codigoFabricante ?? '').toString().trim(),
      desconto,
      numeroAtoConcessorioDrawback,
      transientFatDoctoIUuid: raw?.transientFatDoctoIUuid || raw?.fatDoctoI?.uuid || '',
      uuid: (raw?.uuid ?? '').toString().trim(),
      issueDate: null as any,
      updatedAt: null as any,
      usuarioLog: null,
    };
  }

  private onlyNumbers(value: string): string {
    return (value ?? '').toString().replace(/\D/g, '');
  }

  private parseOptionalInteger(value: any): any {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const digits = this.onlyNumbers(String(value));
    return digits ? Number(digits) : null;
  }

  private parseOptionalDecimal(value: any, fallback = null): any {
    if (value === null || value === undefined || value === '') {
      return fallback;
    }

    const numeric = Number(String(value).replace(',', '.'));
    return Number.isFinite(numeric) ? numeric : fallback;
  }

  private formatCnpj(value: string): string {
    const digits = this.onlyNumbers(value);
    if (digits.length !== 14) {
      return value ?? '';
    }

    return digits.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

  private normalizeBackendMessage(raw: string): string {
    const normalized = raw
      .replace(/\uFFFD/g, '?')
      .replace(/\s{2,}/g, ' ')
      .trim();

    const upper = normalized.toUpperCase();
    const semAcento = upper
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');

    const isErroDiImportacao =
      (upper.includes('CFOP [3]') || semAcento.includes('CFOP [3]')) &&
      (upper.includes('DECLARA') || semAcento.includes('DECLARA')) &&
      (upper.includes('IMPORTA') || semAcento.includes('IMPORTA')) &&
      (upper.includes('NÃO INFORMADO') || semAcento.includes('NAO INFORMADO') || upper.includes('N?O INFORMADO'));

    if (isErroDiImportacao) {
      return 'CFOP de importação (3xxx) exige DI no item. Preencha os dados da Declaração de Importação (número, data, local/UF de desembaraço e demais campos) para concluir a emissão.';
    }

    const isProdutoInvalido = semAcento.includes('PRODUTO INVALIDO PARA EMISSAO');
    if (isProdutoInvalido) {
      const cfopMatch = normalized.match(/CFOP\s*\[[^\]]+\][^\n]*/i);
      const produtoMatch = normalized.match(/Produto inválido para emissão:[^\n]*/i);
      const detalhe = [produtoMatch?.[0], cfopMatch?.[0]].filter(Boolean).join(' | ');
      if (detalhe) {
        return detalhe;
      }
      return 'Produto inválido para emissão. Revise CFOP e dados de DI do item.';
    }

    if (normalized.length <= 300) {
      return normalized;
    }

    return `${normalized.substring(0, 297)}...`;
  }


  displayFnCadastro(cad: Cadastro | string): string {
    if (!cad) {
      return '';
    }
    if (typeof cad === 'string') {
      return cad;
    }
    return `${(cad.codigo ?? 0).toString().padStart(6, '0')} - ${cad.nomeFantasia ?? cad.razaoSocial ?? ''}`.trim();
  }

  displayFnCidade(cidade: Cidade | string): string {
    if (!cidade) {
      return '';
    }
    if (typeof cidade === 'string') {
      return cidade;
    }
    return `${cidade.municipio} - ${cidade.uf}`;
  }

  onSelectionChangeCnpj(event: any): void {
    const cad = event?.option?.value as Cadastro;
    if (!cad) {
      return;
    }

    const cnpj = this.formatCnpj(cad.inscricaoFederal);

    this.fatDoctoIDIForm.patchValue({ cnpj });
    if (cad.cadMun?.uf) {
      this.fatDoctoIDIForm.patchValue({ ufTerceiro: cad.cadMun.uf });
    }
  }

  onSelectionChangeExportador(event: any): void {
    const cad = event?.option?.value as Cadastro;
    if (!cad) {
      return;
    }
    this.fatDoctoIDIForm.patchValue({ codigoExportador: String(cad.codigo ?? '') });
  }

  onSelectionChangeFabricante(event: any): void {
    const cad = event?.option?.value as Cadastro;
    if (!cad) {
      return;
    }
    this.fatDoctoIDIForm.patchValue({ codigoFabricante: String(cad.codigo ?? '') });
  }

  onSelectionChangeCidadeDesembaraco(event: any): void {
    const cidade = event?.option?.value as Cidade;
    if (!cidade) {
      return;
    }
    this.fatDoctoIDIForm.patchValue({
      localDesembaraco: cidade.municipio,
      ufDesembaraco: cidade.uf,
    });
  }

  private bindAutocompleteCnpj(): void {
    this.fatDoctoIDIForm.get('cnpj')?.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoadingCnpj = true),
        switchMap(value => this.buscarCadastros(value, 2, false)
          .pipe(finalize(() => this.isLoadingCnpj = false))),
        takeUntil(this._onDestroy)
      )
      .subscribe(cadastros => this.cadastrosCnpj = cadastros);
  }

  private bindAutocompleteExportador(): void {
    this.fatDoctoIDIForm.get('codigoExportador')?.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoadingExportador = true),
        switchMap(value => this.buscarCadastros(value, 2, false)
          .pipe(finalize(() => this.isLoadingExportador = false))),
        takeUntil(this._onDestroy)
      )
      .subscribe(cadastros => this.cadastrosExportador = cadastros);
  }

  private bindAutocompleteFabricante(): void {
    this.fatDoctoIDIForm.get('codigoFabricante')?.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoadingFabricante = true),
        switchMap(value => this.buscarCadastros(value, 2, false)
          .pipe(finalize(() => this.isLoadingFabricante = false))),
        takeUntil(this._onDestroy)
      )
      .subscribe(cadastros => this.cadastrosFabricante = cadastros);
  }

  private bindAutocompleteCidadeDesembaraco(): void {
    this.fatDoctoIDIForm.get('localDesembaraco')?.valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.isLoadingCidadeDesembaraco = true),
        switchMap(value => this.buscarCidades(value)
          .pipe(finalize(() => this.isLoadingCidadeDesembaraco = false))),
        takeUntil(this._onDestroy)
      )
      .subscribe(cidades => this.cidadesDesembaraco = cidades);
  }

  private buscarCadastros(value: any, minLength = 2, preferOnlyNumbers = false): Observable<Cadastro[]> {
    const searchRaw = this.extractSearchValue(value);
    if (!searchRaw) {
      return of([]);
    }

    const search = preferOnlyNumbers ? this.onlyNumbers(searchRaw) : searchRaw;
    if (!search || search.length < minLength) {
      return of([]);
    }

    return this.cadastroService
      .getCadastroPageSearch(1, 10, search, 'NENHUM', 'ASC', false, 'TODOS')
      .pipe(map(page => page?.content ?? []));
  }

  private extractSearchValue(value: any): string {
    if (typeof value === 'string') {
      return value.trim();
    }
    if (typeof value === 'number') {
      return String(value);
    }
    if (value && typeof value === 'object') {
      return '';
    }
    return '';
  }

  private buscarCidades(value: any): Observable<Cidade[]> {
    if (value && typeof value === 'object') {
      return of([]);
    }

    const search = this.extractSearchValue(value);
    if (!search || search.length < 2) {
      return of([]);
    }

    return this.cidadeService
      .getCidadePageSearch(1, 10, search)
      .pipe(map(page => page?.content ?? []));
  }


  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }

  close() {
    this.confirmService.confirm({ message: 'Deseja realmente fechar? Poderá haver perda de dados.' })
      .subscribe(res => {
        if (res) {
          this.dialogRef.close();
        }
      });
  }

}
